import React from 'react';
import { BannerWrapper, OuterContainer, Background, Play } from './styles';
import { ModalBox } from '../ModalBox';
import FallBackImageForNoImage from '@/components/NextImage/assets/fallback_image.webp';
import Image from 'next/image';
import NextImage from '../NextImage';
import { ImagesService } from 'service/images/imagesService';
import type { AiLabelType } from '@/types/Recipes';

export interface IHeroBannerRDPProps {
  title?: string;
  image?: {
    desktop?: string;
    mobile?: string;
    imageAlt?: string;
    width?: number;
    height?: number;
    mimeType?: string;
    aiLabeling?: boolean;
    aiLabelType?: AiLabelType;
  };
  mobileImage?: Record<string, string>;
  video?: string;
  videoData?: any;
  description: string;
  thumbnailUrls?: string[];
  embedUrl?: string;
  uploadDate?: string;
  duration?: string;
  interactionCount?: number;
  keywords?: string;
  recipeCuisine?: string;
  recipeCategory?: string;
}

export const HeroBannerRDP = ({
  image,
  video,
  videoData,
  description,
  thumbnailUrls,
  embedUrl,
  uploadDate,
  duration,
  interactionCount,
  keywords,
  recipeCategory,
  recipeCuisine,
}: IHeroBannerRDPProps) => {
  // Desktop-only hero: omit `mobile` so getPictureSources does not emit a mobile breakpoint.
  const sources =
    image?.desktop != null && image.desktop !== ''
      ? ImagesService.getPictureSources({
          desktop: image.desktop,
          width: image.width,
          height: image.height,
          mimeType: image.mimeType,
        })
      : [];

  const sourcesAreEmpty = sources.length === 0 || sources.every((source) => !source.srcSet);

  return (
    <OuterContainer role="presentation" className="z-0">
      <Background className="curve-mask-bottom" $customColor="#EFDBB2">
        <div className="curve-mask-bottom">
          <BannerWrapper>
            <div className="relative w-full h-0 pb-[calc(50%+62px)]">
              <div className="w-full h-full absolute left-0 [&_img]:h-full">
                {!sourcesAreEmpty && (
                  <NextImage
                    className="bg-cover"
                    width={1920}
                    height={800}
                    sources={sources}
                    alt={image?.imageAlt || 'Hero image'}
                    aiLabeling={image?.aiLabeling}
                    aiLabelType={image?.aiLabelType}
                    priority
                    loading="eager"
                  />
                )}

                {/* // fallback image */}
                {sourcesAreEmpty && (
                  <Image
                    className="bg-cover top-0 left-0 w-full h-full"
                    alt="Flour with eggs"
                    src={FallBackImageForNoImage}
                    priority
                  />
                )}
              </div>
            </div>
          </BannerWrapper>
        </div>
      </Background>
      {video ? (
        <Play data-test="video-play" data-print="hide">
          <ModalBox
            data-test="video-modal-box"
            videoID={videoData}
            description={description}
            thumbnailUrls={thumbnailUrls}
            embedUrl={embedUrl}
            uploadDate={uploadDate}
            duration={duration}
            interactionCount={interactionCount}
            video={video}
            keywords={keywords}
            recipeCategory={recipeCategory}
            recipeCuisine={recipeCuisine}
          />
        </Play>
      ) : null}
    </OuterContainer>
  );
};
